import { PublicCallback } from 'globals/types';
import { handleError } from 'globals/errors';
import { fetchCategories, fetchRootCategory } from 'core_main/api/categories';
import {
  createCategoryCallbackResponse,
  createRootCategoryCallbackResponse,
} from './helpers';
import {
  CategoryCallbackResponse,
  GetCategoriesCallbackResponse,
  GetCategoriesParameters,
} from './types';

export const fetchAllCategories = (
  parameters: GetCategoriesParameters,
  page = 1,
  categories = {},
): Promise<GetCategoriesCallbackResponse['categories']> => {
  const fetchCategoriesParams = {
    page,
    lang: parameters?.lang,
    knowledgeBaseId: parameters?.knowledgeBaseId,
  };

  return fetchCategories(fetchCategoriesParams).then((res) => {
    const reducedCategories = res.data.reduce((acc, val) => {
      const { id } = val;
      acc[id] = createCategoryCallbackResponse(val);

      return acc;
    }, categories);

    const newCategories = { ...categories, ...reducedCategories };

    if (res.links?.next) {
      return fetchAllCategories(parameters, page + 1, newCategories);
    }

    return categories;
  });
};

export const getCategories = (
  parameters: GetCategoriesParameters,
  cb?: PublicCallback,
) => {
  const callbackResponse = {
    categories: {},
    rootCategory: {} as CategoryCallbackResponse,
  };

  return fetchRootCategory(parameters)
    .then((res) => {
      callbackResponse.rootCategory = createRootCategoryCallbackResponse(
        res.data,
      );

      return fetchAllCategories(parameters);
    })
    .then((categories) => {
      const { rootCategory } = callbackResponse;
      const rootCategoryId = rootCategory.categoryId;

      callbackResponse.categories = categories;
      callbackResponse.categories[rootCategoryId] = rootCategory;

      if (typeof cb === 'function') {
        cb(callbackResponse);
      }
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      handleError(error, { message: 'Failed to get categories' });
    });
};
